import { createRouter } from '@tanstack/react-router'
import { tanstackRouteTree } from './tanstackRouteTree'

export const createTanstackRouter = (head = '') =>
  createRouter({
    routeTree: tanstackRouteTree,
    context: {
      head
    },
    defaultPreload: 'intent',
    scrollRestoration: true
  })

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createTanstackRouter>
  }
}
